<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
const store = useStore();

const isRTL = computed(() => store.state.isRTL);
</script>
<template>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-lg-6 mb-lg-0">
          <div class="text-sm text-center copyright text-muted" :class="isRTL ? 'text-lg-end' : 'text-lg-start'">
            ©
            {{ new Date().getFullYear() }}, hecho con
            <i class="fa fa-heart"></i> por
            <a href="https://www.idamedic.me" class="font-weight-bold" target="_blank">iDAMedic,</a>
            software con inteligencia.
          </div>
        </div>
        <div class="col-lg-6">
          <ul class="nav nav-footer justify-content-center justify-content-lg-end">
            <li class="nav-item">
              <a href="https://www.idamedic.me" class="nav-link text-muted" target="_blank">iDAMedic</a>
            </li>
            <li class="nav-item">
              <a href="https://www.idamedic.me" class="nav-link text-muted" target="_blank">Videos</a>
            </li>
            <li class="nav-item">
              <a href="https://www.idamedic.me" class="nav-link pe-0 text-muted" target="_blank">Terminos y
                condiciones</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
